export default __webpack_public_path__ + "static/media/canteen_logo.87d681a5.png";